module.exports = "/_next/static/images/circlestar-monotone-51d0dacfffcc5a31eb601f3e1e6c626a.svg";